export default __webpack_public_path__ + "static/media/desktop_tc3_En.16ac4386.webp";